import React, { useEffect, useState } from "react";
import Select from "react-select";
import countriesData from "../../common/country.json";

const CountrySelect = ({ validation, fieldName = "country" }) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    setCountries(
      countriesData.map((country) => ({
        label: `${country.flag} ${country.name}`,
        value: country.name,
      }))
    );
  }, []);

  return (
    <Select
      options={countries}
      name={fieldName}
      id={`${fieldName}-field`}
      placeholder="Select Country"
      classNamePrefix="react-select"
      onChange={(selectedOption) =>
        validation.setFieldValue(fieldName, selectedOption.value)
      }
      onBlur={() => validation.setFieldTouched(fieldName, true)}
      value={countries.find(
        (option) => option.value === validation.values[fieldName]
      )}
    />
  );
};

export default CountrySelect;
